import React from 'react'

import Button from '@toasttab/shared/src/components/atoms/Button/Button'
import TextLink from '@toasttab/shared/src/components/molecules/TextLink/TextLink'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'

const TwoColumnTicker = ({ body }: { body: any }) => {
  return (
    <section className='mb-10 lg:mb-16'>
      <div className='ds-wrapper'>
        <div className='ds-container lg:ds-grid mb-10 lg:mb-16'>
          <div className='col-span-4 lg:col-span-6 justify-center content-center mb-10 pr-0 lg:pr-[72px] lg:max-w-[548px]'>
            <Typography
              as='h2'
              variation='h2'
              classes='font-effra font-normal text-[1.938rem] lg:text-[3.313rem] leading-[2.5rem] lg:leading-[4rem] mb-6 px-[4rem] lg:px-0 lg:pr-40 text-center lg:text-left text-primary text-primary'
              allowHtml={false}
            >
              {body.columns.left.heading}
            </Typography>
            {body.columns.left.lineItems.map((lineItem: any, i: number) => {
              return (
                <div className='mb-6 text-center lg:text-left' key={i}>
                  <Typography
                    as='h4'
                    variation='h4'
                    classes='font-effra !font-normal inline text-[1.375rem] pr-1 text-primary'
                  >
                    {lineItem.primary}
                  </Typography>
                  <Typography
                    as='h4'
                    variation='h4'
                    classes='font-effra !font-normal inline text-[1.375rem] text-secondary'
                  >
                    {lineItem.secondary}
                  </Typography>
                </div>
              )
            })}
            <div className='flex flex-col lg:flex-row items-center lg:items-start text-center lg:text-left'>
              <Button
                classes='mb-6 lg:mb-0 lg:mr-6 border-none hover:border-none !w-auto'
                fontWeight={['font-semibold']}
                heapInteraction='hprefine_pricingbtn_click'
                href={body.columns.left.cta.href}
                size='medium'
                variation='primary'
              >
                {body.columns.left.cta.text}
              </Button>
              <TextLink
                classes='!flex justify-self-center lg:!inline-flex lg:justify-self-start'
                heapInteraction='hprefine_switchto_click'
                href={body.columns.left.link.href}
                icon='arrow'
                text={body.columns.left.link.text}
              />
            </div>
          </div>
          <div className='col-span-4 lg:col-span-6 hidden lg:block max-w-[548px]'>
            <img src={body.columns.right.assets.image.src} alt='' />
          </div>
        </div>
        <div className='ds-container lg:ds-grid'>
          <div className='col-span-4 lg:col-span-12 lg:relative lg:before:absoltue lg:after:absoltue lg:before:top-0 lg:after:top-0 lg:before:left-0 lg:after:right-0 lg:before:content-[""] lg:after:content-[""] lg:before:z-20 lg:after:z-20 lg:before:w-[420px] lg:before:h-[56px] lg:after:w-[420px] lg:after:h-[56px] lg:before:absolute lg:after:absolute lg:before:bg-left-white-gradient lg:after:bg-right-white-gradient'>
            <div className='overflow-hidden w-full lg:max-w-[1430px]'>
              <ul className='flex justify-center items-center p-4 animate-marquee space-x-10 whitespace-nowrap'>
                {body.tickerItems.map((tickerItem: any, i: number) => {
                  return (
                    <li
                      className='before:content-icon-orange-check before:mr-2 inline ml-12 text-secondary'
                      key={`item-set-1-${i}`}
                    >
                      <Typography
                        as='h5'
                        variation='h5'
                        classes='text-secondary inline font-semibold text-[22px]'
                      >
                        {tickerItem.label}
                      </Typography>
                    </li>
                  )
                })}
                {body.tickerItems.map((tickerItem: any, i: number) => {
                  return (
                    <li
                      className='before:content-icon-orange-check before:mr-2 inline ml-12'
                      key={`item-set-2-${i}`}
                    >
                      <Typography
                        as='h5'
                        variation='h5'
                        classes='text-secondary inline font-semibold text-[22px]'
                      >
                        {tickerItem.label}
                      </Typography>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TwoColumnTicker
